/* eslint-disable import/prefer-default-export */
export const FLAGS = {
  SINGPASS_LOGIN: 'sso-singpass-login',
  DECOUPLE_LUCKY_DRAW: 'sso-decouple-lucky-draw-consent',
};
